import { inject, Injectable } from '@angular/core';
import { NavigationMockApi } from '#root/mock-api/common/navigation/api';

@Injectable({ providedIn: 'root' })
export class MockApiService {
    navigationMockApi = inject(NavigationMockApi);
}
